module.exports = __webpack_public_path__ + "img/mc_cafe.b8e3a0dc.png";